export default __webpack_public_path__ + "static/media/projects-icon.174194ca.svg";